import type { Site } from '@gitbook/api-client';
import { useConfigurationTheme } from '@gitbook/react-uikit';
import { Icon, type SVGIconProps } from '@gitbook/spine-icons';

import { ControlledContentIcon } from '../Content';

/**
 * Get the site icon component based on the site's publication status.
 */
export function getSiteIcon(site: Site) {
    return site.published ? Icon.DocsSite : Icon.DocsSiteUnpublished;
}

/**
 * Icon for a site with its publication status.
 */
export function SiteIcon({ site, ...props }: { site: Site } & SVGIconProps) {
    const IconComponent = getSiteIcon(site);
    return <IconComponent {...props} />;
}

/**
 * Icon for a site representing the icon used in the content.
 */
export function SiteContentIcon({
    site,
    ...props
}: {
    site: Site;
    size?: number;
    className?: string;
}) {
    const theme = useConfigurationTheme();
    if (site.icon && 'emoji' in site.icon) {
        return (
            <ControlledContentIcon
                emoji={site.icon.emoji}
                iconURL={undefined}
                fallbackText={site.title}
                withBackground={false}
                {...props}
            />
        );
    }
    if (site.icon && 'icon' in site.icon) {
        return (
            <ControlledContentIcon
                iconURL={site.icon.icon[theme.color]}
                emoji={undefined}
                withBackground={false}
                fallbackText={site.title}
                {...props}
            />
        );
    }
    return (
        <ControlledContentIcon
            iconURL={undefined}
            emoji={undefined}
            fallbackText={site.title}
            {...props}
        />
    );
}
